/**
 * Extracts ID from API Platform response item containing a _link attribute which contains references URIs.
 * @param {*} item - The object to extract the id from.
 * @param {string} refName - The name of the reference field.
 * @returns {number|null} - Returns the extracted id or null if not found.
 */
export function extractIdFromRefLink(item, refName) {
  if (item?._links) {
    const links = item?._links
    const refLink = links[refName]
    if (!!refLink && refLink.href) {
      return parseInt(refLink.href.match(/\d+$/)) || null
    }
  }
  return null
}
